import { Banner, Button } from '@innovationdepartment/proxima-ui';
import { CastingProfileLayout, CenteredState } from './CastingProfile.styles';
import type { CastingMetadata } from './CastingProfile.types';
import CastingProfileForm from './Form/CastingProfileForm';
import SaveCastingProfileConfirmation from './SaveCastingProfileConfirmation';
import type useCastingProfileForm from './useCastingProfileForm';

type CastingProfileViewProps = {
  loading: boolean;
  loadError: string | null;
  metadata: CastingMetadata | null;
  profileExists: boolean;
  form: ReturnType<typeof useCastingProfileForm>;
  saving: boolean;
  confirmingSave: boolean;
  onSaveRequest: () => void;
  onSaveConfirm: () => void;
  onSaveCancel: () => void;
  onRetry: () => void;
};

const CastingProfileView = ({
  loading,
  loadError,
  metadata,
  profileExists,
  form,
  saving,
  confirmingSave,
  onSaveRequest,
  onSaveConfirm,
  onSaveCancel,
  onRetry
}: CastingProfileViewProps) => {
  // While loading, the global overlay spinner (useShowSpinner in the container) is visible
  if (loading) return null;

  if (loadError || !metadata) {
    return (
      <CenteredState>
        <Banner
          type="error"
          title="Unable to load casting profile"
          body={loadError ?? 'Unknown error'}
        />
        <Button label="Retry" size="small" onClick={onRetry} />
      </CenteredState>
    );
  }

  return (
    <CastingProfileLayout>
      {!profileExists && (
        <Banner
          type="info"
          title="No casting profile yet"
          body="This brand has not been profiled. Fill out the form below and save to create its casting profile."
        />
      )}
      <CastingProfileForm form={form} metadata={metadata} saving={saving} onSave={onSaveRequest} />
      <SaveCastingProfileConfirmation
        open={confirmingSave}
        onConfirm={onSaveConfirm}
        onCancel={onSaveCancel}
      />
    </CastingProfileLayout>
  );
};

export default CastingProfileView;
